// src/components/LiveStream.js
import React from 'react';

export default function LiveStream() {
  return (
    <div className="bg-gray-800 text-white p-6 rounded-xl text-center w-96">
      <h2 className="text-xl mb-2">?? Live Stream</h2>
      <p>Live streaming feature coming soon!</p>
      <button className="bg-blue-500 px-4 py-2 rounded mt-3">Start Stream</button>
    </div>
  );
}